export enum PaymentMethod {
  MANGOPAY = 'MANGOPAY',
  OFFLINE_PAYMENT = 'OFFLINE_PAYMENT'
}
